import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SmsRoutingModule } from './sms-routing.module';
import { SmsComponent } from './sms/sms.component';
import { ReactiveFormsModule } from '@angular/forms';
import { WhitelistListComponent } from './whitelist-list/whitelist-list.component';
import { SharedModule } from '../shared/shared.module';
import { LogsDataService } from '../logs/plugins/logs-data.service';


@NgModule({
  declarations: [
    SmsComponent,
    WhitelistListComponent
  ],
  imports: [
    CommonModule,
    SmsRoutingModule,
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [
    LogsDataService
  ]
})
export class SmsModule { }
